export const throwError = (error) => {
    throw new Error(`[vue-router-next] ${error}`);
};
export function assert(condition, message) {
    if (!condition) {
        throwError(message);
    }
}
